<template>
  <!-- w-19 h-15 -->
  <path
    d="M17 7.4372L17.7703 6.79956L18.2931 7.43108L17.7763 8.06752L17 7.4372ZM12.448 14.6303C12.0999 15.0591 11.4701 15.1245 11.0413 14.7763C10.6126 14.4282 10.5472 13.7984 10.8953 13.3697L12.448 14.6303ZM10.9013 1.63764C10.5492 1.2122 10.6086 0.581826 11.034 0.229668C11.4594 -0.122491 12.0898 -0.0630825 12.442 0.362362L10.9013 1.63764ZM1.32232e-06 6.4372L17 6.4372L17 8.4372L9.72631e-07 8.4372L1.32232e-06 6.4372ZM17.7763 8.06752L12.448 14.6303L10.8953 13.3697L16.2237 6.80689L17.7763 8.06752ZM16.2297 8.07484L10.9013 1.63764L12.442 0.362362L17.7703 6.79956L16.2297 8.07484Z"
    fill="#939393"
  />
</template>
